export { initialAbility as initialAbility };
export { _ as _ };
const initialAbility = [{
  action: 'read',
  subject: 'Auth'
}];
const _ = undefined;

export default { initialAbility };
